module.exports = __webpack_public_path__ + "invoice.cdeea861.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/invoice.png
// module id = 902
// module chunks = 0